import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { QuizResult, ScentFamily } from '@/types'

interface ScentProfileState {
  result: QuizResult | null
  ownedPerfumeIds: string[]
  wishlistIds: string[]
  subscription: 'none' | 'monthly' | 'bi-monthly'
  setResult: (result: QuizResult) => void
  clearResult: () => void
  addOwned: (id: string) => void
  toggleWishlist: (id: string) => void
  setWishlistIds: (ids: string[]) => void
  clearWishlist: () => void
  setSubscription: (plan: 'none' | 'monthly' | 'bi-monthly') => void
}

export const useScentProfileStore = create<ScentProfileState>()(
  persist(
    (set) => ({
      result: null,
      ownedPerfumeIds: [],
      wishlistIds: [],
      subscription: 'none',

      setResult: (result) => set({ result }),
      clearResult: () => set({ result: null }),
      addOwned: (id) =>
        set((state) => ({
          ownedPerfumeIds: state.ownedPerfumeIds.includes(id)
            ? state.ownedPerfumeIds
            : [...state.ownedPerfumeIds, id],
        })),
      toggleWishlist: (id) =>
        set((state) => ({
          wishlistIds: state.wishlistIds.includes(id)
            ? state.wishlistIds.filter((x) => x !== id)
            : [...state.wishlistIds, id],
        })),
      setWishlistIds: (ids) => set({ wishlistIds: ids }),
      clearWishlist: () => set({ wishlistIds: [] }),
      setSubscription: (subscription) => set({ subscription }),
    }),
    { name: 'little-sky-profile' }
  )
)

export function getPrimaryScentFamily(result: QuizResult | null): ScentFamily | null {
  return result?.primary ?? null
}
